import { ObjetivoService } from 'src/app/modulos/elementos-plan/services/objetivo.service';
import { LineaAccionService } from 'src/app/modulos/elementos-plan/services/linea-accion.service';
import { PlanAccionService } from 'src/app/modulos/elementos-plan/services/plan.accion.service';
import { ProcesoService } from 'src/app/modulos/elementos-plan/services/proceso.service';
import { ProyectoService } from 'src/app/modulos/elementos-plan/services/proyecto.service';
import { FormBuilder, Validators, UntypedFormGroup, FormArray, FormControl } from '@angular/forms';
import { Component, OnDestroy, OnInit, ViewChild, Input, NgModule } from '@angular/core';
import { AmbienteService } from 'src/app/modulos/catalogos-admin/services/ambiente.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  public dataObjetivo: any;
  public dataLineaAccion: any;
  public dataPlanAccion: any;
  public dataProyecto: any;
  public dataProceso: any;
  public dataAmbiente!: any;
  public buffer: any;
  public currentAmbiente: any;

  constructor(
    private ObjetivoService: ObjetivoService,
    private LineaAccionService: LineaAccionService,
    private PlanAccionService: PlanAccionService,
    private ProcesoService: ProcesoService,
    private ambienteService: AmbienteService,
    private ProyectoService: ProyectoService,
  ) {
    this.buffer = localStorage.getItem('currentUser')
    this.currentAmbiente = JSON.parse(this.buffer);
  }

getDataObjetivo(){
this.ObjetivoService.list()
.subscribe(resp => {
  this.dataObjetivo=resp;
}
  )
}

getDataLineaAccion(){
  this.LineaAccionService.list()
  .subscribe(resp => {
    this.dataLineaAccion=resp;
  }
    )
  }

  getDataPlanAccion(){
    this.PlanAccionService.list()
    .subscribe(resp => {
      this.dataPlanAccion=resp;
    }
      )
    }
  
    getDataProceso(){
      this.ProcesoService.list()
      .subscribe(resp => {
        this.dataProceso=resp;
      }
        )
      }
      getDataProyecto(){
        this.ProyectoService.list()
        .subscribe(resp => {
          this.dataProyecto=resp;
        }
          )
        }

        listAmbiente(idSprAmbiente: number) {
          this.ambienteService.list(`${idSprAmbiente}` ).subscribe((resp) => {
            this.dataAmbiente = resp;
            
          });
        }




}

